<div class="main-content">
  <div *ngIf="isLoading" class="overlay">
    <div class="spinner"></div>
  </div>
  <div class="container-fluid">
    <div class="row mb-6">
      <div class="col-md-6">
        <a class="btn btn-dark btn-sm btn-initial" (click)="back()"> Back </a>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon">
              <i class="material-icons">perm_identity</i>
            </div>
            <h4 class="card-title">{{ id ? "Update" : "New" }} customer</h4>
          </div>

          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="contact_name"
                      >Fullname</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="contact_name"
                      formControlName="contact_name"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('contact_name')"
                    >
                      The fullname is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="company_name"
                      >Company</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="company_name"
                      formControlName="company_name"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('company_name')"
                    >
                      The company is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="email">Email</label>
                    <input
                      type="text"
                      class="form-control"
                      id="email"
                      formControlName="email"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('email')"
                    >
                      The email is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="address">Address</label>
                    <input
                      type="text"
                      class="form-control"
                      id="address"
                      formControlName="address"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('address')"
                    >
                      The address is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="phone">Phone</label>
                    <input
                      type="text"
                      class="form-control"
                      id="phone"
                      formControlName="phone"
                    />
                  </div>
                </div>
              </div>

              <button
                type="submit"
                class="btn btn-dark btn-sm pull-right btn-initial"
                [disabled]="form.invalid"
              >
                {{ id ? "Update" : "Create" }}
              </button>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
